var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"active":1}}),_c('Render1'),_c('Render2'),_c('Render3'),_c('Position'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }